module.exports = {"450107001":"衡阳街道","450107002":"北湖街道","450107003":"西乡塘街道","450107004":"安吉街道","450107005":"华强街道","450107006":"新阳街道","450107007":"上尧街道","450107008":"安宁街道","450107009":"石埠街道","450107010":"心圩街道","450107100":"金陵镇","450107101":"双定镇","450107105":"坛洛镇","450107450":"那龙矿务局","450107454":"高新技术开发区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450107.json
// module id = 2198
// module chunks = 0